import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  accentNote: {
    color: colors.gilead.primary1,
    marginBottom: 8,
    marginTop: 8,
    fontSize: 12,
  },
  root: {
    borderBottom: '1px solid #c6cac640',
    display: 'flex',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1),
    },
  },
  description: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      marginBottom: theme.spacing(0.5),
    },
  },
  rating: {
    color: '#929A92',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1.5),
      '& #rateable': {
        marginLeft: 0,
      },
    },
  },
}));
